<template>
  <div class="header-logo" align="center">
    <div class="header-image">
      <img src="@/assets/images/gshc.png" :alt="logoAlt" class="logo-image" />
      <span class="company-name">{{ companyName }}</span>
    </div>
    <div class="header-image">
      <span class="company-name">{{ companyRight }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeaderLogo',
  props: {
    logoSrc: {
      type: String,
      default: '@/assets/images/gshc.png'
    },
    logoAlt: {
      type: String,
      default: 'logo'
    },
    companyName: {
      type: String,
      default: "甘肃豪创信息技术有限公司"
    },
    companyRight: {
      type: String,
      default: "©陇ICP备2024010868号-3 版权所有"
    },
    logoWidth: {
      type: String,
      default: '25px'
    },
    logoHeight: {
      type: String,
      default: '20px'
    }
  }
}
</script>

<style scoped>
.header-logo {
  justify-content: center;
  /*align-items: center;*/
  width: 100%;
/*  position: absolute;
  bottom: 0;*/
}


.header-image {
  display:inline-flex;
 /* gap: 8px;*/
}

.logo-image {
  width: v-bind(logoWidth);
  height: v-bind(logoHeight);
}

.company-name {
  color: #606266;
  font-size: 14px;
  font-weight: 400;
  display: inline-block;
}
</style>
